var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "design-chart",
          attrs: {
            title: _vm.title,
            center: "",
            width: "80%",
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                size: "small",
                model: _vm.inputForm,
                disabled: _vm.method === "view",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.doSubmit()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-container",
                [
                  _c(
                    "el-container",
                    [
                      _c(
                        "el-aside",
                        {
                          staticStyle: { "padding-left": "15px" },
                          attrs: { width: "250px" },
                        },
                        [
                          _c("p", [_vm._v("请选择一个数据源：")]),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "215px",
                                "padding-top": "5px",
                              },
                              attrs: {
                                filterable: "",
                                placeholder: "请选择一个数据源",
                              },
                              on: { change: _vm.resetMetas },
                              model: {
                                value: _vm.inputForm.dataSet.id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm.dataSet, "id", $$v)
                                },
                                expression: "inputForm.dataSet.id",
                              },
                            },
                            _vm._l(_vm.dataSets, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                          _c(
                            "draggable",
                            {
                              staticClass: "jp-filed-panel",
                              attrs: { list: _vm.metas, group: "charts" },
                              on: { change: _vm.log },
                            },
                            _vm._l(_vm.metas, function (element, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "list-group-item" },
                                [
                                  _c("i", { staticClass: " fa fa-arrows " }, [
                                    _vm._v(" " + _vm._s(element.label)),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-main",
                        { staticClass: "eMain" },
                        [
                          _c(
                            "el-header",
                            { staticClass: "eHeader" },
                            [
                              _c(
                                "el-menu",
                                {
                                  staticClass: "el-menu-dm",
                                  attrs: { mode: "horizontal" },
                                  on: { select: _vm.handleSelect },
                                },
                                [
                                  _c(
                                    "el-submenu",
                                    { attrs: { index: "1" } },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v("基本图表"),
                                      ]),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "line" } },
                                        [_vm._v("折线图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "histogram" } },
                                        [_vm._v("柱状图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "bar" } },
                                        [_vm._v("条形图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "pie" } },
                                        [_vm._v("饼图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "ring" } },
                                        [_vm._v("环形图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "waterfall" } },
                                        [_vm._v("瀑布图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "funnel" } },
                                        [_vm._v("漏斗图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "radar" } },
                                        [_vm._v("雷达图")]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-submenu",
                                    { attrs: { index: "2" } },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v("复杂图表"),
                                      ]),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "heatmap" } },
                                        [_vm._v("热力图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "scatter" } },
                                        [_vm._v("散点图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "candle" } },
                                        [_vm._v("K线图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "gauge" } },
                                        [_vm._v("仪表盘")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "wordcloud" } },
                                        [_vm._v("词云图")]
                                      ),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "liquidfill" } },
                                        [_vm._v("水球图")]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-submenu",
                                    { attrs: { index: "3" } },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v("地图"),
                                      ]),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "map" } },
                                        [_vm._v("中国地图")]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-submenu",
                                    { attrs: { index: "4" } },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v("其他"),
                                      ]),
                                      _c(
                                        "el-menu-item",
                                        { attrs: { index: "table" } },
                                        [_vm._v("表格")]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "el-btn-dm",
                                      attrs: { type: "text" },
                                      on: { click: _vm.handleGenerateCode },
                                    },
                                    [_vm._v("生成代码")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { staticClass: "chartMain", attrs: { gutter: 12 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-card",
                                    { staticClass: "jp-box-card" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "clearfix",
                                          attrs: { slot: "header" },
                                          slot: "header",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "fa fa-list",
                                              staticStyle: {
                                                "font-weight": "800",
                                              },
                                            },
                                            [_vm._v(" X轴")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "draggable",
                                        {
                                          staticClass: "fieldpanel",
                                          attrs: {
                                            list: _vm.xMetas,
                                            group: "charts",
                                          },
                                          on: {
                                            add: _vm.onMove,
                                            change: _vm.log,
                                          },
                                        },
                                        _vm._l(
                                          _vm.xMetas,
                                          function (element, index) {
                                            return _c(
                                              "li",
                                              {
                                                key: index,
                                                staticClass: "list-group-item",
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      " fa fa-arrows ",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(element.label)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-card",
                                    { staticClass: "jp-box-card" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "clearfix",
                                          attrs: { slot: "header" },
                                          slot: "header",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "fa fa-list",
                                              staticStyle: {
                                                "font-weight": "800",
                                              },
                                            },
                                            [_vm._v(" Y轴")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "draggable",
                                        {
                                          staticClass: "fieldpanel",
                                          attrs: {
                                            list: _vm.yMetas,
                                            group: "charts",
                                          },
                                          on: { change: _vm.log },
                                        },
                                        _vm._l(
                                          _vm.yMetas,
                                          function (element, index) {
                                            return _c(
                                              "li",
                                              {
                                                key: index,
                                                staticClass: "list-group-item",
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      " fa fa-arrows ",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(element.label)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-card",
                                    { staticClass: "chartMain" },
                                    [
                                      _vm.inputForm.type === "table"
                                        ? [
                                            _c(
                                              "el-table",
                                              {
                                                attrs: {
                                                  data: _vm.chartData.rows,
                                                },
                                              },
                                              _vm._l(
                                                _vm.chartData.columns,
                                                function (column, index) {
                                                  return _c("el-table-column", {
                                                    key: index,
                                                    attrs: {
                                                      prop: column,
                                                      label: column,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        : [
                                            _vm.custom
                                              ? _c("ve-" + _vm.inputForm.type, {
                                                  ref: "chart",
                                                  tag: "component",
                                                  attrs: {
                                                    legend:
                                                      _vm.activeOption.legend,
                                                    grid: _vm.activeOption.grid,
                                                    extend:
                                                      _vm.activeOption.extend,
                                                    tooltip:
                                                      _vm.activeOption.tooltip,
                                                    data: _vm.chartData,
                                                    colors:
                                                      _vm.activeOption.colors,
                                                    title:
                                                      _vm.activeOption.title,
                                                  },
                                                })
                                              : _c("ve-" + _vm.inputForm.type, {
                                                  ref: "chart",
                                                  tag: "component",
                                                  attrs: {
                                                    data: _vm.chartData,
                                                  },
                                                }),
                                          ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-aside",
                        {
                          staticStyle: {
                            "padding-right": "15px",
                            "padding-left": "15px",
                            "border-left": "1px solid rgb(238, 238, 238)",
                          },
                          attrs: { width: "280px" },
                        },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                "label-width": "100px",
                                "label-position": "left",
                                size: "mini",
                              },
                            },
                            [
                              [
                                _c(
                                  "p",
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        model: {
                                          value: _vm.custom,
                                          callback: function ($$v) {
                                            _vm.custom = $$v
                                          },
                                          expression: "custom",
                                        },
                                      },
                                      [_vm._v("开启自定义配置")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.custom
                                  ? _c("common-option")
                                  : _c("el-alert", {
                                      attrs: {
                                        title:
                                          "不使用自定义配置，将按照默认风格展示echarts图表，生成的代码会比较简洁，不包含复杂的配置项。",
                                        type: "info",
                                        closable: false,
                                        "show-icon": "",
                                      },
                                    }),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: {
                visible: _vm.codeVisible,
                "close-on-click-modal": false,
                width: "800px",
                center: "",
                "append-to-body": "",
                title: "生成代码",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.codeVisible = $event
                },
              },
            },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { "box-shadow": "none" },
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.codeActiveName,
                    callback: function ($$v) {
                      _vm.codeActiveName = $$v
                    },
                    expression: "codeActiveName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "动态数据", name: "dy" } },
                    [
                      _c("editor", {
                        attrs: {
                          lang: "html",
                          theme: "twilight",
                          width: "100%",
                          height: "450px",
                        },
                        on: { init: _vm.editorInit },
                        model: {
                          value: _vm.dyTemplate,
                          callback: function ($$v) {
                            _vm.dyTemplate = $$v
                          },
                          expression: "dyTemplate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "静态数据", name: "static" } },
                    [
                      _c("editor", {
                        attrs: {
                          lang: "html",
                          theme: "twilight",
                          width: "100%",
                          height: "450px",
                        },
                        on: { init: _vm.editorInit },
                        model: {
                          value: _vm.staticTemplate,
                          callback: function ($$v) {
                            _vm.staticTemplate = $$v
                          },
                          expression: "staticTemplate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:copy",
                          value: _vm.codeCopyValue,
                          expression: "codeCopyValue",
                          arg: "copy",
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:success",
                          value: _vm.onCopy,
                          expression: "onCopy",
                          arg: "success",
                        },
                        {
                          name: "clipboard",
                          rawName: "v-clipboard:error",
                          value: _vm.onError,
                          expression: "onError",
                          arg: "error",
                        },
                      ],
                      attrs: { type: "text" },
                    },
                    [_vm._v(" 拷贝代码 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }